export const Z_INDICES = {
  adminSubNav: '900',
  navBar: '800'
};
